export default {
  'menu.home': 'Casa',
  'menu.login': 'Iniciar sessão',
  'menu.register': 'Inscrição',
  'menu.account.logout': 'Logout',
  'menu.about': 'Sobre',
  'menu.product':'Produto',
  'menu.product.challenge-rules':'Regras do Desafio',
  'menu.product.elite-competition':'Competição de Elite',
  'menu.product.personal-challenge':'Desafio Pessoal',
  'menu.product.month-challenge':'Desafio Mensal',
  'menu.develop':'Desenvolver',
  'menu.develop.partnership-program':'Programa de Parceria',
  'menu.develop.trader-recruitment':'Recrutamento de Traders',
  'menu.download':'Baixar',
  'menu.FAQ':'Perguntas Freqüentes',
  'menu.account': 'Centro Individual',
  'menu.account.personal': 'Perfil',
  'menu.account.instrument-panel': 'Painel',
  'menu.account.purchaseEvaluation': 'Avaliação de Compra',
  'menu.account.earn': 'Promoção',
  'menu.account.payout': 'ativos',
  'menu.account.certificate': 'Certificado',
  'menu.account.paymentRecords': 'Faturamento',
  'menu.account.contactUs': 'Fale Conosco',


  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.register-result': 'Resultado de registro',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Análise',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Ambiente de Trabalho',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulário',
  'menu.form.basic-form': 'Formulário Básico',
  'menu.form.step-form': 'Formulário Assistido',
  'menu.form.step-form.info': 'Formulário Assistido(gravar informações de transferência)',
  'menu.form.step-form.confirm': 'Formulário Assistido(confirmar informações de transferência)',
  'menu.form.step-form.result': 'Formulário Assistido(finalizado)',
  'menu.form.advanced-form': 'Formulário Avançado',
  'menu.list': 'Lista',
  'menu.list.table-list': 'Tabela de Busca',
  'menu.list.basic-list': 'Lista Básica',
  'menu.list.card-list': 'Lista de Card',
  'menu.list.search-list': 'Lista de Busca',
  'menu.list.search-list.articles': 'Lista de Busca(artigos)',
  'menu.list.search-list.projects': 'Lista de Busca(projetos)',
  'menu.list.search-list.applications': 'Lista de Busca(aplicações)',
  'menu.profile': 'Perfil',
  'menu.profile.basic': 'Perfil Básico',
  'menu.profile.advanced': 'Perfil Avançado',
  'menu.result': 'Resultado',
  'menu.result.success': 'Sucesso',
  'menu.result.fail': 'Falha',
  'menu.exception': 'Exceção',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Disparar',
  'menu.account': 'Conta',
  'menu.account.center': 'Central da Conta',
  'menu.account.settings': 'Configurar Conta',
  'menu.account.trigger': 'Disparar Erro',
  'menu.account.logout': 'Sair',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
